import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ExpandableCardController extends Controller {
  static targets = ['trigger', 'body', 'lessIcon', 'moreIcon']
  static values = {
    opened: { type: Boolean }
  }

  connect () {
    this.updateVisibility()
  }

  toggle () {
    this.openedValue = !this.openedValue
    this.updateVisibility()
  }

  updateVisibility () {
    this.#toggleTriggerAttrs(this.openedValue)
    this.#toggleTriggerClasses(this.openedValue)
    this.#toggleBodyClasses(this.openedValue)
    this.#toggleIcon(this.openedValue)
  }

  #toggleTriggerAttrs (isOpened) {
    if (isOpened) {
      this.triggerTarget.setAttribute('aria-expanded', 'true')
    } else {
      this.triggerTarget.setAttribute('aria-expanded', 'false')
    }
  }

  #toggleTriggerClasses (isOpened) {
    if (isOpened) {
      this.triggerTarget.classList.add('card__header-bordered')
    } else {
      this.triggerTarget.classList.remove('card__header-bordered')
    }
  }

  #toggleBodyClasses (isOpened) {
    if (isOpened) {
      this.bodyTarget.classList.remove('card__body-collapsible_closed')
      this.bodyTarget.classList.add('card__body-collapsible_opened')
    } else {
      this.bodyTarget.classList.remove('card__body-collapsible_opened')
      this.bodyTarget.classList.add('card__body-collapsible_closed')
    }
  }

  #toggleIcon (isOpened) {
    if (isOpened) {
      this.lessIconTarget.classList.remove('hidden')
      this.moreIconTarget.classList.add('hidden')
    } else {
      this.lessIconTarget.classList.add('hidden')
      this.moreIconTarget.classList.remove('hidden')
    }
  }
}

stimulus.register('expandable-card', ExpandableCardController)
